"use client";

import { Fragment } from "react";
import { useRouter } from "next/navigation";
import { Popover, Transition } from "@headlessui/react";
import { Character } from "schema";

import { trpc } from "~/app/providers";
import RecordLineModal from "~/components/RecordLineModal";
import { LineBucket } from "../page";
import CreateLineModal from "./CreateLineModal";
import EditLineModal from "./EditLineModal";

export default function LineDropDown({
  characters,
  stageHands,
  lineBucket,
  userCastList,
}: {
  characters: Character[];
  stageHands: Character[];
  lineBucket: LineBucket;
  userCastList: number[];
}) {
  const router = useRouter();

  const deleteLine = trpc.lines.deleteLine.useMutation({
    onSuccess: () => {
      router.refresh();
    },
  });

  //   {
  //     id: number;
  //     playId: number;
  //     text: string;
  //     characterId: number;
  //     bucket: number;
  //     created_at: Date | null;
  // }

  const {
    lineId: id,
    playId,
    lineText: text,
    characterId,
    created_at,
    id: bucket,
  } = lineBucket;

  const line = {
    id,
    bucket,
    playId,
    text,
    characterId,
    created_at,
  };

  return (
    <div className="w-full max-w-sm px-4">
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button
              className={`
                ${open ? "text-gray" : "text-gray/90"}
                hover:text-gray focus-visible:ring-gray/75 group inline-flex  items-center rounded-md px-3 py-2 text-base font-medium focus:outline-none focus-visible:ring-2`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                />
              </svg>
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {({ close }) => (
                  <>
                    <div className="py-1">
                      <EditLineModal
                        close={close}
                        lineBucket={lineBucket}
                        characters={characters}
                        stageHands={stageHands}
                      />
                    </div>
                    <div className="py-1">
                      <CreateLineModal
                        characters={characters}
                        stageHands={stageHands}
                        insert={{
                          pos: "before",
                          node: lineBucket,
                        }}
                        close={close}
                      />
                      <CreateLineModal
                        characters={characters}
                        stageHands={stageHands}
                        insert={{
                          pos: "after",
                          node: lineBucket,
                        }}
                        close={close}
                      />
                    </div>
                    {userCastList.includes(lineBucket.characterId) ? (
                      <div className="py-1">
                        <RecordLineModal line={line} close={close} />
                      </div>
                    ) : null}
                    <div className="py-1">
                      <button
                        className="flex w-full items-center gap-1 px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                        onClick={() =>
                          deleteLine.mutate({
                            lineId: lineBucket.lineId,
                            lineBucketId: lineBucket.id,
                            next: lineBucket.next,
                            prev: lineBucket.prev,
                          })
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="size-5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                          />
                        </svg>
                        Delete
                      </button>
                    </div>
                  </>
                )}
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}
